import React, {useEffect, useState} from "react";
import classes from "./whatsapp.module.css";
import {MobileDatePicker} from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {Typography, Select, MenuItem} from "@mui/material";

const daysArray = ["7", "15", "30", "60", "90"];

const Step1 = ({setName, setMobileNo, setLanguage, language, setStartDate, setEndDate, startDate, endDate, errorMsgs}) => {
  const [selectedDays, setSelectedDays] = useState();

  useEffect(() => {
    if (+selectedDays >= 0) {
      setStartDate(dayjs());
      const toDate = dayjs().add(selectedDays - 1, "day");
      setEndDate(dayjs(toDate));
    }
  }, [selectedDays]);

  return (
    <div className={classes.step1}>
      <div className={classes.step1_section1}>
        <div className={classes.step1_section1_header}>
          <div>Tell us about you</div>
        </div>
        <div className={classes.inputBox}>
          <div className={classes.inputBoxLabel}>Name</div>
          <input onChange={(e) => setName(e.target.value)} type="text" placeholder="Type your name here" />
          {errorMsgs.find((err) => err.input === "name") && <div className={classes.errorMessage}>{errorMsgs.find((err) => err.input === "name").msg}</div>}
        </div>

        <div className={classes.inputBox}>
          <div className={classes.inputBoxLabel}>Phone Number</div>
          <input onChange={(e) => setMobileNo(e.target.value)} type="number" placeholder="Type phone number here" />
          {errorMsgs.find((err) => err.input === "mobileNo") && <div className={classes.errorMessage}>{errorMsgs.find((err) => err.input === "mobileNo").msg}</div>}
        </div>

        <div className={classes.inputBox}>
          <div className={classes.inputBoxLabel}>Select Language</div>
          <Select
            value={language}
            onChange={(e) => {
              console.log(e.target.value);
              setLanguage(e.target.value);
            }}
            size="small"
            displayEmpty
            sx={{
              border: "1px solid #EEEEEE", // custom border color
              borderRadius: "8px",
              padding: "5px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none", // remove default border
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none", // remove focus border
              },
              "&:focus": {
                outline: "none",
                boxShadow: "none",
              },
              "&.Mui-focused": {
                boxShadow: "none",
                border: "1px solid #1976d2", // keep same border on focus
              },
            }}
            className={classes.languageSelect}
            inputProps={{"aria-label": "Without label"}}>
            <MenuItem value={"English"}>English</MenuItem>
            <MenuItem value={"Hindi"}>Hindi</MenuItem>
            <MenuItem value={"Kannada"}>Kannada</MenuItem>
            <MenuItem value={"Tamil"}>Tamil</MenuItem>
            <MenuItem value={"Telugu"}>Telugu</MenuItem>
          </Select>
        </div>
      </div>

      <div className={classes.step1_section2}>
        <div className={classes.step1_section1_header}>
          <div>Select prescription period</div>
        </div>
        <div className={classes.prescriptionDays}>
          {daysArray?.map((day) => {
            return (
              <div onClick={() => setSelectedDays(day)} className={selectedDays === day && classes.selectedPrescriptionDays}>
                {day}D
              </div>
            );
          })}
        </div>
        <div className={classes.datePicker}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className={classes.datePickerOutderDiv}>
              {/* Start Date */}
              <div flex={1} className={classes.dateInputDiv}>
                <Typography fontSize={12} mb={0.5} color="text.secondary">
                  From
                </Typography>
                <MobileDatePicker
                  value={startDate}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setStartDate(newValue);
                    setSelectedDays();
                    if (endDate && newValue.isAfter(endDate)) {
                      setEndDate(null); // reset endDate if it's before startDate
                    }
                  }}
                  maxDate={endDate || undefined}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      className: classes.datePickerTextField,
                      InputProps: {
                        disableUnderline: true,
                        style: {
                          border: "none",
                          backgroundColor: "transparent",
                          cursor: "pointer",
                        },
                      },
                      inputProps: {
                        readOnly: true,
                      },
                    },
                  }}
                />
              </div>
              &nbsp;&nbsp; - &nbsp;&nbsp;
              {/* End Date */}
              <div flex={1} className={classes.dateInputDiv}>
                <Typography fontSize={12} mb={0.5} color="text.secondary">
                  To
                </Typography>
                <MobileDatePicker
                  format="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate || undefined}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                    setSelectedDays();
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      className: classes.datePickerTextField,
                      InputProps: {
                        disableUnderline: true,
                        style: {
                          border: "none",
                          backgroundColor: "transparent",
                          cursor: "pointer",
                        },
                      },
                      inputProps: {
                        readOnly: true,
                      },
                    },
                  }}
                />
              </div>
            </div>
          </LocalizationProvider>
        </div>
        {errorMsgs.find((err) => err.input === "date") && <div className={classes.errorMessage}>{errorMsgs.find((err) => err.input === "date").msg}</div>}
      </div>
    </div>
  );
};

export default Step1;
